import { buildPath, buildTemplatePath, Page, PageRoute } from "@compass/core";
import { Permission, SurveyExportResource } from "generated/openApi";
import "moment-timezone";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";
import { CobroSurveyExportBody } from "./CobroSurveyExportBody";
import { CobroSurveyExportHeader } from "./CobroSurveyExportHeader";

const routeName = "cobroSurveyExport";

export const cobroSurveyExportPageRoute: PageRoute = {
  handle: "Survey Export",
  templatePath: buildTemplatePath(routeName),
  getPath: () => buildPath(routeName),
};

export const CobroSurveyExportPage = () => {
  const [viewResource, setViewResource] = useState<SurveyExportResource>({});
  const [surveyId, setSurveyId] = useState<number>();
  const [exportTypeId, setExportTypeId] = useState<number>();

  const getExportResource = () => {
    ApiService.surveyExport.getSurveyExportResource().then((response) => {
      setViewResource(response);
      setExportTypeId(response.exportTypes![0].id);
    });
  };

  const onChangeSurveyId = (surveyId) => {
    setSurveyId(surveyId);
  };

  const onChangeExportType = (exportTypeId) => {
    setExportTypeId(exportTypeId);
  };

  useEffect(() => {
    getExportResource();
  }, []);

  return (
    <Page
      header={
        <CobroSurveyExportHeader handle={cobroSurveyExportPageRoute.handle} surveyId={surveyId} exportTypeId={exportTypeId} />
      }
    >
      <CobroSurveyExportBody
        surveyId={surveyId}
        exportTypeId={exportTypeId}
        setSurveyId={onChangeSurveyId}
        setExportTypeId={onChangeExportType}
        viewResource={viewResource}
      />
    </Page>
  );
};
